import { Component, EventEmitter, Output, OnInit, Renderer2, ViewChild, NgZone } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject } from 'rxjs';
import { DataService } from '../blacklist/service/data.service';
import { BackendApiService } from '../service/backendapi.service';
import { EndpointsService } from '../service/endpoints.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as XLSX from 'xlsx'
import { ExportToCsv } from 'export-to-csv';

@Component({
  selector: 'app-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.scss']
})
export class CommunityComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  @Output() refreshTableData = new EventEmitter();
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  isDisabled: boolean;
  communityForm: FormGroup;
  communityGroup: FormGroup;
  closeResult: string;
  //multy select items
  homeTadigList = [];
  visitingTadigList = [];
  homeNetworkSelectedItems = [];
  dropdownSettings = {};
  visitingNetworkList = [];
  visitingNetworkSelectedItems = [];
  tarrifList = [];
  tarrifSelectedItems = [];
  tableData = [];
  isCommunityFormEdit = false;
  isCommunityFormView = true;
  editIndex = null;
  checkMOC = false;
  checkMTC = false;
  checkSMSMO = false;
  checkGPRS = false;
  checkDataOthers = false;
  disabled = "";
  communityData:any;
  communityData1: [];
  communityData2: [];
  communityData3: [];
  communityData4: any;
  showTable: boolean;
  itemData: any;
  communityId: [];
  communityValue: any;
  public mode: string;
  public countryFilterPlaceholder = 'Search Country Name';
  public countryCheckFields: Object = { text: 'country', value: 'country' }
  public countryCheckWaterMark = 'Select Country';
  selectedCountry: any = [];
  countryMultiSelectAction: boolean;
  globalCountrySelected: string = '';
  alreadyselectedCountry: any = [];
  public networkFilterPlaceholder = 'Search Network Name';
  public networkCheckFields: Object = { text: 'country', value: 'country' }
  public networkCheckWaterMark = 'Select Network';
  selectedNetwork: any = [];
  networkMultiSelectAction: boolean;
  globalNetworkSelected: string = '';
  alreadyselectedNetwork: any = [];
  public homeTadIgFilterPlaceholder = 'Search homeTadig';
  public homeTadIgCheckFields: Object = { text: 'country', value: 'country' }
  public homeTadIgCheckWaterMark = 'Select homeTadig Name';
  selectedhomeTadIg: any = [];
  homeTadIgMultiSelectAction: boolean;
  globalhomeTadIgSelected: string = '';
  alreadyselectedhomeTadIg: any = [];
  public visitingTadIgFilterPlaceholder = 'Search visiting Tadig';
  public visitingTadIgCheckFields: Object = { text: 'country', value: 'country' }
  public visitingTadIgCheckWaterMark = 'Select visitingTadig Name';
  selectedvisitingTadIg: any = [];
  visitingTadIgMultiSelectAction: boolean;
  globalvisitingTadIgSelected: string = '';
  alreadyselectedvisitingTadIg: any = [];
  numb: any;
  titleHeader = 'Add Community';
  expandedRows: { [key: number]: boolean } = {};
  title:any='Community'
  fileName:any;
  dataToBeDownloaded: any =[];

  checkMOCButton() {
    if (this.checkMOC === false) {
      this.checkMOC = true;
    } else {
      this.checkMOC = false;
      this.communityForm.controls.MOC.setValue('');
      this.communityForm.controls.MOC_text.setValue('');
    }
  }

  checkMTCButton() {
    if (this.checkMTC === false) {
      this.checkMTC = true;
    } else {
      this.checkMTC = false;
      this.communityForm.controls.MTC.setValue('');
      this.communityForm.controls.MTC_text.setValue('');
    }
  }

  checkSMSMOButton() {
    if (this.checkSMSMO === false) {
      this.checkSMSMO = true;
    } else {
      this.checkSMSMO = false;
      this.communityForm.controls.SMSMO.setValue('');
      this.communityForm.controls.SMSMO_text.setValue('');
    }
  }

  checkGPRSButton() {
    if (this.checkGPRS === false) {
      this.checkGPRS = true;
    } else {
      this.checkGPRS = false;
      this.communityForm.controls.GPRS.setValue('');
      this.communityForm.controls.GPRS_text.setValue('');
    }
  }

  checkDataOthersButton() {
    if (this.checkDataOthers === false) {
      this.checkDataOthers = true;
    } else {
      this.checkDataOthers = false;
      this.communityForm.controls.dataOthers.setValue('');
      this.communityForm.controls.dataOthers_text.setValue('');
    }
  }

  addCommunity = {
    '1': 'All',
    '2': 'com1',
    '3': 'com2',
    '4': 'com3'
  }

  constructor(private modalService: NgbModal,
    private renderer: Renderer2, private spinnerService: Ng4LoadingSpinnerService,
    private dataService: DataService,
    private formBuilder: FormBuilder, private router: Router,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

  open(content2, isNewItem?: boolean) {
    if (isNewItem) {
      this.titleHeader='Add Community'
      this.reset();
      this.isCommunityFormEdit = false;
      this.isCommunityFormView = true;
      this.communityForm.enable();
      this.disabled = "";
    }
    this.modalService.open(content2 , {keyboard: false, backdrop:'static'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed `;
    });
  }

  ngOnInit() {
    this.communityValue = sessionStorage.getItem('userCommunity');
    
    this.tableData = this.communityData;
    // this.isDisabled = true;
    this.dtOptions = {
      paging: true,
      pagingType: 'full_numbers',
      scroller: true,
      scrollCollapse: true,
      scrollX: true,
      responsive: true,
      select: true,
      dom: '<\'row\'<\'col-sm-12 col-md-3\'l><\'col-sm-12 col-md-3\'B><\'col-sm-12 col-md-6\'f>>' +
        '<\'row\'<\'col-sm-12\'tr>>' +
        '<\'row\'<\'col-sm-12 col-md-3 entries\'i><\'col-sm-12 col-md-9 entries\'p>>',
      buttons: [
        {
          text: 'CSV',
          action: () => {
            this.downloadcsv(this.communityData, this.title); // or any filtered data array
            this.storeAnalytics();
          }
        },
        {
          text: 'excel',
          action: () => {
              
              this.exportTable(this.title);
              this.storeAnalytics();
            },
        }
      ]
    };
    this.tableData = this.getData();
    this.renderer.removeClass(document.body, 'campaignModel');
    this.renderer.removeClass(document.body, 'businessModel');
    this.renderer.addClass(document.body, 'communityModel');
    this.communityForm = this.formBuilder.group({
      communityName : [],
      vpmnCountry: [],
      vpmnNetwork: [],
      ecowasEnabled: [],
      messageEnabled: [],
      chargingEnabled: [],
      homeTadIg: [],
      visitingTadIg: [],
      tarrifName: [],
      freeRoamValidity: [],
      counterValidity: [],
      messageInterval: [],
      stayHomeInterval: [],
      counterStayHomeInterval: [],
      ratesApplied: [],
      MOC: [],
      MTC: [],
      SMSMO: [],
      GPRS: [],
      dataOthers: [],
      MOC_text: [],
      MTC_text: [],
      SMSMO_text: [],
      GPRS_text: [],
      dataOthers_text: [],
      community_id: []
    })

    //community rules
    this.communityGroup = this.formBuilder.group({
      community: [''],
      country: [''],
      network: ['']
    })

    //multi select
    this.homeTadigList = [
      { country: 'TADIG1' },
      { country: 'TADIG2' },
      { country: 'TADIG3' },
      { country: 'TADIG4' },
      { country: 'TADIG5' },
      { country: 'TADIG6' },
    ];
    this.visitingTadigList = [
      { country: 'TADIG1' },
      { country: 'TADIG2' },
      { country: 'TADIG3' },
      { country: 'TADIG4' },
      { country: 'TADIG5' }
    ];
    this.homeNetworkSelectedItems = [];
    this.visitingNetworkList = [
      { item_id: 1, item_text: 'India' },
      { item_id: 2, item_text: 'Usa' }
    ];
    this.visitingNetworkSelectedItems = [];
    this.tarrifList = [
      { item_id: 1, item_text: 'India' },
      { item_id: 2, item_text: 'Usa' }
    ];
    this.tarrifSelectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'country',
      textField: 'country',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      //itemsShowLimit: 5,
      allowSearchFilter: true
    };
    this.getApiOnLoad();

    //   this.dropdownList = [
    //     { item_id: 1, item_text: 'Mumbai' },
    //     { item_id: 2, item_text: 'Bangaluru' },
    //     { item_id: 3, item_text: 'Pune' },
    //     { item_id: 4, item_text: 'Navsari' },
    //     { item_id: 5, item_text: 'New Delhi' }
    //   ];
    //   this.selectedItems = [
    //     { item_id: 3, item_text: 'Pune' },
    //     { item_id: 4, item_text: 'Navsari' }
    //   ];
    //   this.dropdownSettings1:IDropdownSettings = {
    //     singleSelection: false,
    //     idField: 'item_id',
    //     textField: 'item_text',
    //     selectAllText: 'Select All',
    //     unSelectAllText: 'UnSelect All',
    //     itemsShowLimit: 3,
    //     allowSearchFilter: true
    //   };
    // }
    // onItemSelect(item: any) {
    //   
    // }
    // onSelectAll(items: any) {
    //   

  }

  toggleExpand(index: number): void {
  this.expandedRows[index] = !this.expandedRows[index];
}


downloadcsv(rawData: any[], title: string) {
  console.log('Raw serviceSummaryData:', rawData);

  
  const formattedData = rawData.map(item => ({
    'Community Name': item.communityName,
    'Free Roam Validity': item.freeRoamValidity,
    'Counter Validity': item.counterValidity,
    'Message Interval': item.messageInterval,
    'Stay Home Interval': item.stayHomeInterval,
    'Counter Stay Home Interval': item.counterStayHomeInterval,
    'Rates Applied': item.ratesApplied,
    moc: item.moc,
    mtc: item.mtc,
    smsmo: item.smsmo,
    grps: item.grps,
    'Data Others': item.dataOthers,
    'Vpmn Country':item.vpmnCountry,
    'Vpmn Network':item.vpmnNetwork
  }));

  console.log('Formatted CSV data:', formattedData);

  const options = {
    filename: title,
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true
  };

  const csvExporter = new ExportToCsv(options);
  csvExporter.generateCsv(formattedData);
}

  
  exportTable(title) {
   
   
console.log("tabledata",this.tableData);
console.log("tabledataeeeeee",this.communityData)
    for (let i = 0; i < this.communityData.length; i++) {
      this.dataToBeDownloaded.push({
        'Community Name': this.communityData[i].communityName,
        'Free Roam Validity': this.communityData[i].freeRoamValidity,
        'Counter Validity': this.communityData[i].counterValidity,
        'Message Interval': this.communityData[i].messageInterval,
        'Stay Home Interval': this.communityData[i].stayHomeInterval,
        'Counter Stay Home Interval': this.communityData[i].counterStayHomeInterval,
        'Rates Applied': this.communityData[i].ratesApplied,
        'moc': this.communityData[i].moc,
        'mtc': this.communityData[i].mtc,
        'smsmo': this.communityData[i].smsmo,
        'grps': this.communityData[i].grps,
        'Data Others': this.communityData[i].dataOthers,
        'Vpmn Country':this.communityData[i].vpmnCountry,
        'Vpmn Network':this.communityData[i].vpmnNetwork
         
      });
    }
  
    console.log("Download data ready:", this.dataToBeDownloaded);
    const workSheet = XLSX.utils.json_to_sheet(this.dataToBeDownloaded);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, 'SheetName');
    XLSX.writeFile(workBook, title+'.xlsx');
}
storeAnalytics() {
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
        'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=RRMS Day Wise Reports' + '&operation=download' + '&opname=is_downloaded' + '&opvalue=true';
      this.backendApiService.callToApi(apiUrl1).subscribe(response => {
       console.log(response);
      });
  
    }
// Helper to get a shortened list
getLimitedList(data: string, index: number): string {
  const items = data.split(",");
  if (this.expandedRows[index]) {
    return items.join(", ");
  } else {
    return items.slice(0, 3).join(", ") + (items.length > 3 ? "..." : "");
  }
}

  async getApiOnLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_COMMUNITY_COUNTRY;

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.communityData1 = response;
      

    });
    this.getNetworkdetails();
  }

  getNetworkdetails() {

    this.spinnerService.show();
    const apiUrl = this.endpointsService.URL_GET_COMMUNITY_NETWORK;

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.communityData2 = response;
    });
    this.getCommunityValues();
  }

  getCommunityValues() {

    //  var i;
    // this.spinnerService.show();
    // const apiUrl = this.endpointsService.URL_GET_COMMUNITY +
    // '&community='+'&country='+'&network=';

    // this.backendApiService.callToApi(apiUrl).subscribe(response => {
    //   this.communityData3 = response;
    //   this.communityData4 = this.communityData3.filter((communityName, i) => i === this.communityData3.indexOf(communityName))
    //  

    // });
    var i;
    let uniqueList1: any = [];
    const apiUrl = this.endpointsService.URL_GET_COMMUNITY;

    this.spinnerService.show();
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      
      this.communityData3 = response;
      this.spinnerService.hide();


      for (i = 0; i < response.length; i++) {
        
        if (uniqueList1.indexOf(response[i].communityName) == -1) {
          uniqueList1.push(response[i].communityName);
        } else {
          
        }

      }

      


      this.communityData4 = uniqueList1;
    });


  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  selectEvent($event: any, type) {
    if (type === 'Country_Name') {
      this.countryMultiSelectAction = true;
      this.selectedCountry.push($event.itemData);
    }
    else if (type === 'Network_Name') {
      this.networkMultiSelectAction = true;
      this.selectedNetwork.push($event.itemData);
    }
    else if (type === 'homeTadIg_Name') {
      this.homeTadIgMultiSelectAction = true;
      this.selectedhomeTadIg.push($event.itemData);
    }
    else if (type === 'visitingTadIg_Name') {
      this.visitingTadIgMultiSelectAction = true;
      this.selectedvisitingTadIg.push($event.itemData);
    }
  }

  removeEvent($event: any, type) {
    if (type === 'Country_Name') {
      this.countryMultiSelectAction = true;
      this.deleteItem($event.itemData, this.selectedCountry);
    }
    else if (type === 'Network_Name') {
      this.networkMultiSelectAction = true;
      this.deleteItem($event.itemData, this.selectedNetwork);
    }
    else if (type === 'homeTadIg_Name') {
      this.homeTadIgMultiSelectAction = true;
      this.deleteItem($event.itemData, this.selectedhomeTadIg);
    }
    else if (type === 'visitingTadIg_Name') {
      this.visitingTadIgMultiSelectAction = true;
      this.deleteItem($event.itemData, this.selectedvisitingTadIg);
    }

  }

  deleteItem(val, arr: any[]) {
    const index = arr.indexOf(val);
    if (index !== -1) {
      arr.splice(index, 1);
    }
  }


  closeCountryNameMultiSelect() {
    let countrySelected = '';
    this.selectedCountry.filter(val => {
      countrySelected = countrySelected + val.country + ',';
    });
    if (countrySelected !== '') {
      if (this.countryMultiSelectAction) {
        this.globalCountrySelected = countrySelected.substring(0, countrySelected.length - 1);
        this.countryMultiSelectAction = false;
      }
    } else {
      this.globalCountrySelected = '';
    }
  }
  closehomeTadIgMultiSelect() {
    let homeTadIgSelected = '';
    this.selectedhomeTadIg.filter(val => {
      homeTadIgSelected = homeTadIgSelected + val.country + ',';
    });
    if (homeTadIgSelected !== '') {
      if (this.homeTadIgMultiSelectAction) {
        this.globalhomeTadIgSelected = homeTadIgSelected.substring(0, homeTadIgSelected.length - 1);
        this.homeTadIgMultiSelectAction = false;
      }
    } else {
      this.globalhomeTadIgSelected = '';
    }
  }
  closevisitingTadIgMultiSelect() {
    let visitingTadIgSelected = '';
    this.selectedvisitingTadIg.filter(val => {
      visitingTadIgSelected = visitingTadIgSelected + val.country + ',';
    });
    if (visitingTadIgSelected !== '') {
      if (this.visitingTadIgMultiSelectAction) {
        this.globalvisitingTadIgSelected = visitingTadIgSelected.substring(0, visitingTadIgSelected.length - 1);
        this.visitingTadIgMultiSelectAction = false;
      }
    } else {
      this.globalvisitingTadIgSelected = '';
    }
  }
  closeNetworkNameMultiSelect() {
    let networkSelected = '';
    this.selectedNetwork.filter(val => {
      networkSelected = networkSelected + val.country + ',';
    });
    if (networkSelected !== '') {
      if (this.networkMultiSelectAction) {
        this.globalNetworkSelected = networkSelected.substring(0, networkSelected.length - 1);
        this.networkMultiSelectAction = false;
      }
    } else {
      this.globalNetworkSelected = '';
    }
  }



  onItemSelect(item: any) {
    
  }
  onSelectAll(items: any) {
    
  }

  communityFormSubmit(closeModal) {
    
    this.backendApiService.callToApi(this.endpointsService.URL_INSERT_COMMUNITY +
      '&country=' + this.communityForm.get('vpmnCountry').value +
      '&network=' + this.communityForm.get('vpmnNetwork').value +
      '&communityName=' + this.communityForm.get('communityName').value +
      '&freeRoamValidity=' + this.communityForm.get('freeRoamValidity').value +
      '&counterValidity=' + this.communityForm.get('counterValidity').value +
      '&messageInterval=' + this.communityForm.get('messageInterval').value +
      '&stayHomeInterval=' + this.communityForm.get('stayHomeInterval').value +
      '&counterStayHomeInterval=' + this.communityForm.get('counterStayHomeInterval').value +
      '&ratesApplied=' + this.communityForm.get('ratesApplied').value +
      '&moc=' + this.communityForm.get('MOC_text').value +
      '&mtc=' + this.communityForm.get('MTC_text').value +
      '&sms-mo=' + this.communityForm.get('SMSMO_text').value +
      '&grps=' + this.communityForm.get('GPRS_text').value +
      '&dataOthers=' + this.communityForm.get('dataOthers_text').value
      + '&homeTadIg=' + this.communityForm.get('homeTadIg').value +
      '&vistingTadIg=' + this.communityForm.get('visitingTadIg').value
    )
      .subscribe(response => {
        
        this.spinnerService.hide();
        if (response) {
          alert('Community Added successfully');
          closeModal('close');
          //this.dialogRef.close();
        } else {
          alert('Community Not Added');
        }
        this.onSearch();
      });
    // if (this.communityForm.valid) {
    //   this.tableData.push({ ...this.communityForm.value });
    //   closeModal('close');
    //   this.setData(this.tableData);
    // }
    // this.reset();
  }

  setData(communityFormData) {
    localStorage.setItem('communityData', JSON.stringify(communityFormData));
  }

  getData() {
    var data = localStorage.getItem('communityData');
    if (!data) {
      return [];
    }
    return JSON.parse(data);
  }

  reset() {
    this.communityForm.reset();
    this.homeNetworkSelectedItems = [];
    this.visitingNetworkSelectedItems = [];
    this.tarrifSelectedItems = [];
  }

  //edit business form
  editRecord(index, content2, item) { 
   // this.communityForm.controls.vpmnCountry.setValue(this.communityData[index]['vpmnCountry']);
  // this.communityForm.controls.vpmnNetwork.setValue(this.communityData[index]['vpmnNetwork']);
   this.communityValue=this.communityData[index]['communityName'];
    this.communityForm.controls.freeRoamValidity.setValue(this.communityData[index]['freeRoamValidity']);
    this.communityForm.controls.counterValidity.setValue(this.communityData[index]['counterValidity']);
    this.communityForm.controls.messageInterval.setValue(this.communityData[index]['messageInterval']);
    this.communityForm.controls.stayHomeInterval.setValue(this.communityData[index]['stayHomeInterval']);
    this.communityForm.controls.counterStayHomeInterval.setValue(this.communityData[index]['counterStayHomeInterval']);
    this.communityForm.controls.ratesApplied.setValue(this.communityData[index]['ratesApplied']);
    this.communityForm.controls.MOC_text.setValue(this.communityData[index]['moc']);
    this.communityForm.controls.MTC_text.setValue(this.communityData[index]['mtc']);
    this.communityForm.controls.SMSMO_text.setValue(this.communityData[index]['smsmo']);
    this.communityForm.controls.GPRS_text.setValue(this.communityData[index]['grps']);
    this.communityForm.controls.dataOthers_text.setValue(this.communityData[index]['dataOthers']);
    this.communityForm.controls.homeTadIg.setValue(this.communityData[index]['homeTadIg']);
    this.communityForm.controls.visitingTadIg.setValue(this.communityData[index]['visitingTadIg']);

    this.communityForm.enable();
    this.disabled = "";
    this.titleHeader = 'Edit Community';
    this.open(content2);
    this.isCommunityFormEdit = true;
    this.isCommunityFormView = true;
    this.editIndex = index;
    this.numb = item['community_id'];
    
  }

  editCommunitySubmit(closeModal, index) {

    this.backendApiService.callToApi(this.endpointsService.URL_UPDATE_COMMUNITY +
      '&country=' + this.communityForm.get('vpmnCountry').value +
      '&network=' + this.communityForm.get('vpmnNetwork').value +
      '&communityName='+this.communityForm.get('communityName').value+
      '&freeRoamValidity=' + this.communityForm.get('freeRoamValidity').value +
      '&counterValidity=' + this.communityForm.get('counterValidity').value +
      '&messageInterval=' + this.communityForm.get('messageInterval').value +
      '&stayHomeInterval=' + this.communityForm.get('stayHomeInterval').value +
      '&counterStayHomeInterval=' + this.communityForm.get('counterStayHomeInterval').value +
      '&ratesApplied=' + this.communityForm.get('ratesApplied').value +
      '&moc=' + this.communityForm.get('MOC_text').value +
      '&mtc=' + this.communityForm.get('MTC_text').value +
      '&sms-mo=' + this.communityForm.get('SMSMO_text').value +
      '&grps=' + this.communityForm.get('GPRS_text').value +
      '&dataOthers=' + this.communityForm.get('dataOthers_text').value +
      '&homeTadIg=' + this.communityForm.get('homeTadIg').value +
      '&vistingTadIg=' + this.communityForm.get('visitingTadIg').value
      // +'&sno='+this.communityForm.get(index['community_id'])
      //+ '&userOrgId='+sessionStorage.getItem('userOrgId')+
      + '&sno=' + this.numb
    )
      .subscribe(response => {
       
        this.spinnerService.hide();
        if (response) {
          alert('Updated successfully');
          //this.dialogRef.close();
        } else {
          alert('Not updated.');
        }
        closeModal('close');
        let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
        this.onSearch();
      });

    //   const formData = new FormData();
    //     formData.append('country', this.communityForm.get('country').value);
    //     formData.append('network', this.communityForm.get('network').value);
    //     formData.append('communityName', this.communityForm.get('communityName').value);
    //     formData.append('freeRoamValidity', this.communityForm.get('freeRoamValidity').value);
    //     formData.append('counterValidity', this.communityForm.get('counterValidity').value);
    //     formData.append('messageInterval', this.communityForm.get('messageInterval').value);
    //     formData.append('stayHomeInterval', this.communityForm.get('stayHomeInterval').value);
    //     formData.append('counterStayHomeInterval', this.communityForm.get('counterStayHomeInterval').value);
    //     formData.append('ratesApplied', this.communityForm.get('ratesApplied').value);
    //     formData.append('moc', this.communityForm.get('MOC_text').value);
    //     formData.append('mtc', this.communityForm.get('MTC_text').value);
    //     formData.append('sms-mo', this.communityForm.get('SMSMO_text').value);
    //     formData.append('grps', this.communityForm.get('GPRS_text').value);
    //     formData.append('dataOthers', this.communityForm.get('dataOthers_text').value);
    //     formData.append('homeTadIg', this.communityForm.get('homeTadIg').value);
    //     formData.append('visitingTadIg', this.communityForm.get('visitingTadIg').value);
    //     //formData.append('sno=','89');

    //   this.backendApiService.postApi(this.endpointsService.URL_UPDATE_COMMUNITY, formData ) 
    //       .then(response => {
    //         
    //         this.spinnerService.hide();
    //         if (response === true) {
    //           alert('Updated successfully');
    //           this.isCommunityFormEdit = true;
    //           this.isCommunityFormView = true;

    //         } else {

    //         }
    //       });     
    // // closeModal('close');
    //   this.setData(this.tableData);
    //   this.reset();
  }

  // deleteRecord(index) {
  //   this.tableData.splice(index, 1);
  //   this.setData(this.tableData);
  // }

  viewRecord(index, content2) {
    this.titleHeader = 'View Community';
  //  this.communityForm.controls.vpmnNetwork.patchValue(this.communityData[index]['vpmnNetwork']);
    //this.communityForm.controls.vpmnCountry.patchValue(this.communityData[index]['vpmnCountry']);
    this.communityValue=this.communityData[index]['communityName'];
    this.communityForm.controls.freeRoamValidity.setValue(this.communityData[index]['freeRoamValidity']);
    this.communityForm.controls.counterValidity.setValue(this.communityData[index]['counterValidity']);
    this.communityForm.controls.messageInterval.setValue(this.communityData[index]['messageInterval']);
    this.communityForm.controls.stayHomeInterval.setValue(this.communityData[index]['stayHomeInterval']);
    this.communityForm.controls.counterStayHomeInterval.setValue(this.communityData[index]['counterStayHomeInterval']);
    this.communityForm.controls.ratesApplied.setValue(this.communityData[index]['ratesApplied']);
    this.communityForm.controls.MOC_text.setValue(this.communityData[index]['moc']);
    this.communityForm.controls.MTC_text.setValue(this.communityData[index]['mtc']);
    this.communityForm.controls.SMSMO_text.setValue(this.communityData[index]['smsmo']);
    this.communityForm.controls.GPRS_text.setValue(this.communityData[index]['grps']);
    this.communityForm.controls.dataOthers_text.setValue(this.communityData[index]['dataOthers']);
    this.communityForm.controls.homeTadIg.setValue(this.communityData[index]['homeTadIg']);
    this.communityForm.controls.visitingTadIg.setValue(this.communityData[index]['visitingTadIg']);

    // this.communityForm.disable();
    // this.disabled = "disabled";

    this.open(content2);
    this.isCommunityFormView = false;
    this.isCommunityFormEdit = false;
  }

 
 
   onSearch() {
    this.spinnerService.show();
  
    const apiUrl = this.endpointsService.URL_GET_COMMUNITY +
      '&community=' + this.communityGroup.get('community').value +
      '&country=' + this.communityGroup.get('country').value +
      '&network=' + this.communityGroup.get('network').value;
  
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      // if (!response || response.length === 0) {
      //   this.showTable = false;
      //   this.spinnerService.hide();
      //   return;
      // }
  
     
      if (this.dtElement && this.dtElement.dtInstance) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
  
          this.communityData = response;
          this.showTable = true;
  
          this.spinnerService.hide();
  
          setTimeout(() => {
            this.dtTrigger.next(); 
          }, 0);
        });
      } else {
        this.communityData = response;
        this.showTable = true;
  
        this.spinnerService.hide();
  
        setTimeout(() => {
          this.dtTrigger.next();
        }, 0);
      }
    }, error => {
      console.error(error);
      alert('No Data Found');
      this.spinnerService.hide();
      this.showTable = false;
    });
  }
  
  deleteRow(item: any) {
    if (confirm('Do You Want To Delete ?')) {
      this.spinnerService.show();
      const formData = new FormData();
      this.backendApiService.callToApi(this.endpointsService.URL_DELETE_COMMUNITY +
        '&sno=' + item['community_id'])
        .subscribe(response => {
          if (response === true) {
            alert('Deleted Successfully');
            this.refreshTableData.emit();
            this.onSearch();

          }
          else {
            alert('Not Deleted.Please Check with Administrator');
            this.refreshTableData.emit();
            this.onSearch();

          }
          
          
          this.spinnerService.hide();

        });


    }

    else {
      this.onSearch();
    }

  }
  update(item: any) {

  }

  e(){

    //this.router.navigate(['/BusinessRules']);
  // window.location.reload();
  //this.onSearch();
 
  let currentUrl = this.router.url;
     this.router.routeReuseStrategy.shouldReuseRoute = () => false;
     this.router.onSameUrlNavigation = 'reload';
     this.router.navigate([currentUrl]);
 
   }

}


